<template>
<div class="orders-details">
<el-form :model="dataForm" label-position="top" ref="dataForm" class="formSearch" :rules="rules">
   <div class="title-2">
        <div class="left">
            <h3>货物信息</h3>
            <el-form-item  prop="currencyName" >
            <ab-select
                url="/bas/basCurrency/list"
                placeholder="请选择"
                prefix
                @handleSelect="formChangeData"
                v-model="dataForm.currencyName"
            >
            <template #prefix>
                <div class="text">
                    币别<span>*</span><i></i>
                </div>
            </template>
            </ab-select>
            </el-form-item>
        </div>
        <div>
            <el-button
                :loading="aiLoading"
                @click="aiValidate"
            >AI制单</el-button>

            <el-button
                @click="exportEx"
            >模板下载</el-button>

            <el-upload
                action
                style="display: inline-block;text-indent: 0;margin: 0 10px;"
                :before-upload="beforeAvatarUpload"
                >
                <el-button :loading="exportLoading">EXCEL导入</el-button>
            </el-upload>

            <el-popover
                placement="bottom"
                :width="150"
                trigger="hover"
                popper-class="more-operate"
            >
                <template #reference>
                    <el-button>更多<el-icon class="el-icon--right"><arrow-down /></el-icon></el-button>
                </template>
                <template #default>
                    <el-button
                        type="text"
                        link
                        @click="exportPiPl"
                    >PI&PL模板</el-button>
                    <el-button
                        type="text"
                        link
                        @click="splitData"
                    >数据拆分</el-button>
                </template>
            </el-popover>
        </div>
    </div>

        <el-alert class="ab-lert" v-if="isYellow" title="标黄表示物料还未归类，如需归类，请提交订单" type="warning" @close="() => {this.isYellow = false}" ></el-alert>
        <el-alert class="ab-lert" v-if="!isYellow" title="货物信息表格中的内容，支持Excel复制黏贴，赶快试试吧！" type="warning" @close="() => {this.isYellow = false}" ></el-alert>
        <div class="scoll-vxe">
        <vxe-table
            border
            resizable
            v-if="reload"
            show-overflow
            keep-source
            auto-resize
            :edit-rules="rules"
            ref="xTable"
            max-height="520"
            :row-class-name="rowStyle"
            :data="dataForm.entry"
            :edit-config="{trigger: 'click', mode: 'row', showUpdateStatus: true,icon: 'abcd', autoClear: false}"
            @checkbox-change="checkboxChangeEvent"
            @checkbox-all="checkboxChangeEvent"
            @cell-click="cellClick"
            >
                <vxe-table-column type="checkbox"  align="center" width="60"></vxe-table-column>
                <vxe-table-column type="seq"  align="center" label="序号" width="40">
                    
                </vxe-table-column>
                <vxe-table-column  align="center" title="行操作" width="100">
                    <!-- <template #header>
                        <el-icon><MoreFilled /></el-icon>
                    </template> -->
                    <template #default="{row}">
                        <el-popover effect="light" trigger="hover" placement="bottom-start" width="auto" popper-class="setupRow">
                            <template #default>          
                                <ul class="text">
                                    <li @click="handlerCopyRow(row)">复制行</li>
                                    <li @click="handlerAddBefor(row)">前插行</li>
                                    <li @click="handlerAddEnd(row)">后插行</li>
                                    <li @click="handlerDelRow(row)">删除行</li>
                                </ul>
                            </template>
                            <template #reference>
                                <el-icon><MoreFilled /></el-icon>
                            </template>
                        </el-popover>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="model" title="型号" min-width="300"  show-overflow :edit-render="{autofocus: '.vxe-input--inner'}">
                    <template #header>
                        <el-popover
                            placement="top"
                            popper-class="form-pop"
                            :width="300"
                            trigger="hover"
                            content="产品的编号Model/Part No."
                        >
                            <template #reference>
                                型号
                            </template>
                        </el-popover>
                    </template>
                    <template v-slot="{row}">
                    {{ row.model }}  <span class="model-cls-type" v-if="modelState(row)">{{ modelState(row) }} </span>
                    </template>
                    <template v-slot:edit="{ row }" >
                        <!-- <orderPopover class="edit-cls-type" :isAppend="modelState(row)" :sourceType="sourceType"  @change="modelChange(row)" @clearActived="clearActived" :row="row" fileName="model">
                            <template #default>
                                {{ modelState(row) }} 
                            </template>
                        </orderPopover> -->
                        <ab-select
                            v-model="row.model"
                            class="vxe-table--ignore-clear"
                            url="/wmsbase/client/clientItemPrincipal/pageListAll"
                            inputKey="itemCode"
                            descKey="itemCode"
                            isNotClear
                            placeholder="请输入型号"
                            @handleSelect="handleModel($event, row)"
                        >
                            <template v-slot:content="scope">
                                <div>
                                    型号: {{ scope.item.itemCode }}, 品牌: {{ scope.item.brandName }}, 产地: {{ scope.item.originPlaceName }}
                                </div>
                                
                            </template>
                        </ab-select>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="brand" title="品牌" min-width="150"  :edit-render="{autofocus: '.vxe-input--inner'}" show-header-overflow>
                    <template #header>
                        <el-popover
                            placement="top"
                            popper-class="form-pop"
                            :width="300"
                            trigger="hover"
                            content="产品的牌子Brand"
                        >
                            <template #reference>
                                品牌
                            </template>
                        </el-popover>
                    </template>
                    <template v-slot:edit="{ row }" >
                        <el-input v-model="row.brand" @change="brandChange(row)"  placeholder="请输入" size="mini"></el-input>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="materialName" title="货物名称" width="100" :edit-render="{autofocus: '.vxe-input--inner'}" >
                    <template #header>
                        <el-popover
                            placement="top"
                            popper-class="form-pop"
                            :width="300"
                            trigger="hover"
                            content="产品通用名称Description"
                        >
                            <template #reference>
                                货物名称
                            </template>
                        </el-popover>
                    </template>
                    <template v-slot:edit="{ row }" >
                        <el-input v-model="row.materialName" @blur="materialNameChange(row)"  placeholder="请输入" size="mini"></el-input>
                    </template>
                </vxe-table-column>
                
                <vxe-table-column field="originPlaceName" title="产地" width="130" :edit-render="{autofocus: '.vxe-input--inner .vxe-table--ignore-clear'}" >
                    <template #header>
                        <el-popover
                            placement="top"
                            popper-class="form-pop"
                            :width="300"
                            trigger="hover"
                            content="产品来源国家区域Origin/COO"
                        >
                            <template #reference>
                                产地
                            </template>
                        </el-popover>
                    </template>
                    <!-- <template v-slot="{row}">
                        {{row.originPlaceName}}
                    </template> -->
                    <template v-slot:edit="{ row }" >
                        <!-- <vxe-pulldown ref="xDown2" class="vxe-table--ignore-clear" :transfer="true" >
                            <template v-slot>
                                <vxe-input v-model="row.originPlaceName" placeholder="请选择产地" @blur="inputOrigin($event, row)" @focus="focusEvent2" @keyup="keyupEvent2($event)"></vxe-input>
                            </template>
                            <template v-slot:dropdown>
                                <vxe-list height="200" class="my-dropdown2 " :data="data2" auto-resize style="border:1px solid #e8eaec;">
                                    <template v-slot="{ items }">
                                    <div class="list-item2" v-for="item in items" :key="item.value" @click="selectEvent2(item, row)">
                                        <i class="fa fa-envelope-o"></i>
                                        <span>{{ item.label + ' ' +  item.nameEn + ' ' +  item.number}}</span>
                                    </div>
                                    </template>
                                </vxe-list>
                            </template>
                        </vxe-pulldown> -->
                        <ab-select
                            url='/bas/basArea/listCountry'
                            class="vxe-table--ignore-clear"
                            placeholder="请选择"
                            inputKey="allKeyWord"
                            descKey="name"
                            otherKey="nameEn"
                            threeKey="number"
                            :urlData='{"type":1,"isEnabled":1}'
                            v-model="row.originPlaceName"
                            @handleSelect="selectEvent2($event, row)"
                        >
                        <template #content="scope">
                            {{ scope.item.name + ' ' + scope.item.nameEn + ' ' + scope.item.number}}
                        </template>
                        </ab-select>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="qty" title="数量" width="100"  :edit-render="{autofocus: '.vxe-input--inner'}">
                    <template v-slot:edit="{ row }" >
                        <el-input  @change="qtyChange(row)" @blur="qtyBlur(row)" v-model="row.qty"  placeholder="请输入" size="mini"></el-input>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="baseUnitId" title="单位" width="100" :edit-render="{}" >
                    <!-- <template #header>
                        <el-popover
                            placement="top"
                            popper-class="form-pop"
                            :width="300"
                            trigger="hover"
                            content="默认=个"
                        >
                            <template #reference>
                                单位
                            </template>
                        </el-popover>
                    </template> -->
                    <template v-slot="{row}">
                        {{row.baseUnitName}}
                    </template>
                    <template v-slot:edit="{ row }">
                        <vxe-select v-model="row.baseUnitId" transfer filterable @change="changeBaseUnit($event, row)">
                            <vxe-option v-for="item in unitidArr" :key="item.id" :value="item.id" :label="item.name"></vxe-option>
                        </vxe-select>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="price" title="单价" width="150"  :edit-render="{autofocus: '.vxe-input--inner'}">
                    <template v-slot:edit="{ row }" >
                        <ab-money  
                        @change="priceBlur(row)"
                        style="width: calc(100% - 20px);float: left;" 
                        v-model="row.price"  
                        placeholder="请输入" 
                        size="mini"></ab-money>
                        
                        
                    </template>
                </vxe-table-column>
                <vxe-table-column field="amount"  title="总价" width="150" :edit-render="{autofocus: '.vxe-input--inner'}" >
                    <template v-slot:edit="{ row }" >
                        <ab-money  v-if="reload" @change="amountChange(row)"  v-model="row.amount"  placeholder="请输入" size="mini"></ab-money>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="packedQty" title="件数" width="70" :edit-render="{autofocus: '.vxe-input--inner'}" >
                    <template #header>
                        <el-popover
                            placement="top"
                            popper-class="form-pop"
                            :width="300"
                            trigger="hover"
                            content="箱数Carton/CTN"
                        >
                            <template #reference>
                                件数
                            </template>
                        </el-popover>
                    </template>
                    <template v-slot:edit="{ row }" >
                        <el-input   v-model="row.packedQty"  placeholder="请输入" size="mini"></el-input>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="netWeight" title="净重(kg)" width="90" :edit-render="{autofocus: '.vxe-input--inner'}" >
                    <template #header>
                        <el-popover
                            placement="top"
                            popper-class="form-pop"
                            :width="300"
                            trigger="hover"
                            content="产品本身的重量NetWeight/N.W."
                        >
                            <template #reference>
                                净重
                            </template>
                        </el-popover>
                    </template>
                    <template v-slot:edit="{ row }" >
                        <el-input  @change="countNetWeight" v-model="row.netWeight"  placeholder="请输入" size="mini"></el-input>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="grossWeight" title="毛重(kg)" width="90" :edit-render="{}" >
                    <template #header>
                        <el-popover
                            placement="top"
                            popper-class="form-pop"
                            :width="300"
                            trigger="hover"
                            content="产品含包材的重量Gross Weight/G.W."
                        >
                            <template #reference>
                                毛重
                            </template>
                        </el-popover>
                    </template>
                    <template v-slot:edit="{ row }" >
                        <el-input  @blur="countFn"  v-model="row.grossWeight"  placeholder="请输入" size="mini"></el-input>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="custMatNo" title="料号" width="100" :edit-render="{}" >
                    <template #header>
                        <el-popover
                            placement="top"
                            popper-class="form-pop"
                            :width="300"
                            trigger="hover"
                            content="物料编号Material Code"
                        >
                            <template #reference>
                                料号
                            </template>
                        </el-popover>
                    </template>
                    <template v-slot:edit="{ row }" >
                        <el-input  @blur="custMatNoChange(row)" maxlength="50" v-model="row.custMatNo"  placeholder="请输入" size="mini"></el-input>
                    </template>
                </vxe-table-column>
                
                <!-- <vxe-table-column field="exportRebateRate" title="退税率(%)" width="90" v-if="sourceType == 'out'" ></vxe-table-column> -->
               
               <vxe-table-column field="productSpec" title="产品参数" width="90" v-if="sourceType == 'out'"  :edit-render="{autofocus: '.vxe-input--inner'}">
                    <template v-slot:edit="{ row }" >
                        <el-input   v-model="row.productSpec" maxlength="500" @change="productSpecChange(row)"  placeholder="请输入" size="mini"></el-input>
                    </template>
                </vxe-table-column>
            </vxe-table> 
               
        </div>     

        <div class="addCargo" >
            <div>
                <el-button type="text" @click="addTabItem">
                    <ab-svg name="add"></ab-svg> 新增一行
                </el-button>
            </div>
            <div>
                <el-button type="text" @click="handlerDelete">
                    <ab-svg name="del2"></ab-svg> 删除行
                </el-button>
            </div>
        </div>

            
        <el-row class="cargoMoney">
            <el-col>
                <h5>总金额 <span v-if="dataForm.currencyName">({{ dataForm.currencyName }})</span></h5>
                <div class="number">{{amountTotal}} </div>
            </el-col>
            <el-col>
                <h5>总数量</h5>
                <div class="number">{{expectedSum}}</div>
            </el-col>
            <el-col>
                <h5>总件数</h5>
                <div class="number">{{packedQtySum}}</div>
            </el-col>
            <el-col>
                <h5>总净重（kg）</h5>
                <div class="number">{{netWeightSum}}</div>
            </el-col>
            <el-col>
                <h5>总毛重（kg）</h5>
                <div class="number">{{grossWeightSum}}</div>
            </el-col>
            
        </el-row>

        <div class="cargoRemark">
            <el-form-item label="备注" prop="remark">
                
                
                <el-input v-model="dataForm.remark" maxlength="200" :rows="1" type="textarea" placeholder="有什么问题可以在这里备注哟！" :autosize="{maxRows: 5 }"  resize="none" />
                    
                
            </el-form-item>
                
            <div  class="list-tag-remak">
                <el-tag type="" style="margin-right: 5px;" :closable="obj.tagType ? true : false" @click="handleTagClick(obj)" @close="handleTagClose(obj)" :key="idx" v-for="(obj,idx) in remarkTag">
                    <el-tooltip class="item" effect="dark" :content="obj.content" placement="top-start" :disabled="obj.content.length < 20">
                        <span class="remark-content show-overflow-tooltip" >{{obj.content}}</span>
                    </el-tooltip>
                </el-tag>
            </div>
                
        </div>
    
</el-form>
<ab-ai-make-order @uploadSuccess="$emit('uploadSuccess')" @aiSuccess="$emit('aiSuccess')" ref="aiMakeOrder"></ab-ai-make-order>
<el-dialog title="数据拆分" ref="splitDialog" v-model="splitDialog.show" width="400px" :close-on-click-modal="false">
    <el-row :gutter="30" style="margin-bottom: 10px;">
        <el-col :span="24">
        <el-input v-model="num" placeholder="总件数" size="mini"></el-input>
        </el-col>
    </el-row>
    <el-row :gutter="30" style="margin-bottom: 10px;">
        <el-col :span="24">
            <el-input v-model="netWeight" placeholder="总净重" size="mini"></el-input>
        </el-col>
    </el-row>
    <el-row :gutter="30" style="margin-bottom: 10px;">
        <el-col :span="24">
        <el-input v-model="grossWeight" placeholder="总毛重" size="mini"></el-input>
        </el-col>
    </el-row>
    <template #footer>
        <span class="dialog-footer">
            <el-button @click.stop="closeSplitDialog">取 消</el-button>
            <el-button type="primary" @click.stop="sureBtn">确 定</el-button>
        </span>
    </template>
</el-dialog>
</div>
</template>

<script>
import calculation from '@/utils/calculation'
import clipboard from '@/utils/clipboard'
import orderPopover from './orders-popover.vue'
export default {
    components: {
        orderPopover
    },
    data () {
        return {
            aiLoading: false,
            reload: true,
            exportLoading: false,
            selected: [],
            unitidArr: [],
            list2: [],
            data2: [],
            remarkTag: [
            ],
            splitDialog: {
                show: false
            },
            rules: {
                currencyName: [
                    { required: true, message: '请选择订单币别', trigger: ['blur', 'change'] }
                ],
                remark: [
                    { required: false, message: '请输入备注信息', trigger: 'blur' }
                ],
                model: [
                    { required: true, message: '型号不能为空' },
                    { validator: ({ cellValue }) => {
                        if (cellValue) {
                            if (cellValue.length > 50) {
                              return new Error('型号最大长度50位')
                            }
                        }
                        }
                    }
                ],
                brand: [
                    { required: true, message: '品牌不能为空' },
                    { validator: ({ cellValue }) => {
                        if (cellValue) {
                            if (cellValue.length > 30) {
                            return new Error('品牌最大长度30位')
                            }
                           
                        }
                        }
                    }
                ],
                materialName: [
                    { required: true, message: '品名不能为空' },
                    { validator: ({ cellValue }) => {
                        if (cellValue) {
                            if (cellValue.length > 30) {
                                return new Error('品名最大长度30位')
                            }
                        }
                        }
                    }
                ],
                productSpec: [
                  
                    { validator: ({ cellValue }) => {
                        if (cellValue) {
                            if (cellValue.length > 200) {
                                return new Error('产品参数长度200位')
                            }
                        }
                        }
                    }
                ],
                custMatNo: [
                    { validator: ({ cellValue }) => {
                        if (cellValue) {
                            if (cellValue.length > 50) {
                            return new Error('料号长度50位')
                            }
                            
                        }
                        }
                    }
                ],
                custOrderNo: [
                    { validator: ({ cellValue }) => {
                        if (cellValue) {
                            if (cellValue.length > 50) {
                            return new Error('我司单号长度50位')
                            }
                        }
                        }
                    }
                ],
                baseUnitId: [
                    { required: true, message: '请选择单位' }
                ],
                originPlaceName: [
                    { required: true, message: '请选择产地' }
                ],
                qty: [
                    { required: true, message: '数量不能为空' },
                    { validator: ({ cellValue }) => {
                        if (!cellValue) {
                            return new Error('请输入数量')
                        } else if (cellValue && !/^(?=([0-9]{1,14}$|[0-9]{1,10}\.))(0|[1-9][0-9]*)(\.[0-9]{1,3})?$/.test(cellValue)) {
                            return new Error('请输入数字，最大长度14位，保留三位小数')
                        }
                    }
                    }
                ],
                price: [
                    { required: true, message: '单价不能为空' },
                    { validator: ({ cellValue }) => {
                        if (!cellValue) {
                            return new Error('请输入单价')
                        } else if (cellValue && !/^(?=([0-9]{1,8}$|[0-9]{1,8}\.))(0|[1-9][0-9]*)(\.[0-9]{1,10})?$/.test(cellValue)) {
                            return new Error('请输入数字，最大长度18位，保留十位小数')
                        }
                    }}
                ],
                amount: [
                    { required: true, message: '金额不能为空' },
                    { validator: ({ cellValue }) => {
                        if (!cellValue) {
                            return new Error('请输入金额')
                        } else if (cellValue && !/^(?=([0-9]{1,20}$|[0-9]{1,18}\.))(0|[1-9][0-9]*)(\.[0-9]{1,2})?$/.test(cellValue)) {
                            return new Error('请输入数字，最大长度20位，保留两位小数')
                        }
                    }}
                ],
                netWeight: [
                    { required: false, message: '净重不能为空' },
                    { validator: ({ cellValue }) => {
                        if (cellValue && !/^(?=([0-9]{1,10}$|[0-9]{1,8}\.))(0|[1-9][0-9]*)(\.[0-9]{1,3})?$/.test(cellValue)) {
                            return new Error('请输入数字，最大长度12位，保留三位小数') //劳婷说要改4位小数
                        }
                        }
                    }
                ],
                grossWeight: [
                    { required: false, message: '毛重不能为空' },
                    { validator: ({ cellValue }) => {
                        if (cellValue && !/^(?=([0-9]{1,10}$|[0-9]{1,8}\.))(0|[1-9][0-9]*)(\.[0-9]{1,3})?$/.test(cellValue)) {
                            return new Error('请输入数字，最大长度12位，保留三位小数')
                        }
                        }
                    }
                ],
                packedQty: [
                    { required: false, message: '件数不能为空' },
                    { validator: ({ cellValue }) => {
                        if (cellValue && !/^(?=([0-9]{1,10}$|[0-9]{1,8}\.))(0|[1-9][0-9]*)(\.[0-9]{1,2})?$/.test(cellValue)) {
                            return new Error('请输入数字，最大长度10位，保留两位小数')
                        }
                        }
                    }
                ],
                palletQty: [
                    { validator: ({ cellValue }) => {
                        if (cellValue && !/^\d{1,10}$/.test(cellValue)) {
                            return new Error('请输入整数，最大长度10位')
                        }
                    }}
                ],
                isMultiComponent: [
                    { required: true, message: '请选择多元件' }
                ]
            },
            isYellow: false,
            num: '',
            netWeight: '',
            grossWeight: ''
        }
    },
    props: {
       dataForm: {
            type: Object,
            default: {
                entry: []
            }
        },
       deleteArr: {
            type: Array,
            defalut: []
       },
       packingTypeList: {
            type: Array,
            defalut: []
       },
       isLocked: {
            type: Boolean,
            defalut: false
       },
       sourceType: {
            type: String,
            default: 'import'
       }

    },
    methods: {
        rowStyle ({ row, rowIndex }) {
            if (row && row.classifyStatus === 1) {
                this.isYellow = true
                return 'yellow-row'
            } else {
                return ''
            }
        },
        cellStyle ({row, column, rowIndex, columnIndex}) {
            if (row.increaseFlag && column.property == 'price') {
                return 'red-cell'
            } else if (typeof row.increaseFlag == 'number' && !row.increaseFlag && column.property == 'price') {
                return 'blue-cell'
            }
        },
        formChangeData (v) {
            if (!v) {
                this.dataForm.currencyId = ''
            } else {
                this.dataForm.currencyId = v.id
            }
        },
        aiValidate() {
            if (!this.dataForm.supplierId) {
                this.$message({
                    type: 'error',
                    message: '请先选择供应商！',
                    offset: 380,
                    grouping: true,
                })
                return false
            }
            if (!this.dataForm.bizType) {
                this.$message({
                    type: 'error',
                    message: '请先选择发票类型！',
                    offset: 380,
                    grouping: true,
                })
                return false
            }
            this.aiLoading = true
            this.dataForm.entry = this.dataForm.entry.filter(e => { return e.brand && e.model})
            this.$emit('save')
        },
        aiMakeOrderFn(dataForm) {
            this.aiLoading = false
            this.$refs.aiMakeOrder.init(dataForm)
        },
        exportPiPl () {
          let eleLink = document.createElement('a')
          eleLink.download = ''
          eleLink.style.display = 'none'
          eleLink.href = `https://static.z-easy.com.cn/prod/template/INV-PL-Template.xlsx`
          document.body.appendChild(eleLink)
          eleLink.click()
          document.body.removeChild(eleLink)
        },
        splitData () {
            if (this.selected.length === 0) {
                this.$message({
                    type: 'error',
                    message: '请选择要拆分的数据！',
                    offset: 380,
                    grouping: true,
                })
                return false
            }
            this.splitDialog.show = true
        },
        closeSplitDialog () {
            this.netWeight = ''
            this.grossWeight = ''
            this.num = ''
            this.splitDialog.show = false
        },
        sureBtn () {
            this.splitDialog.show = false
            let cal = calculation
            let Weightsum = 0
            let grossWeightsum = 0
            let packedQtysum = 0
            let maxWeight = 0
            let maxGrossWeight = 0
            let maxPackedQty = 0
            if (this.selected.length === 0) {
                return false
            }
            this.selected.forEach((v, i) => {
                if (!v.qty) {
                v.qty = 0
                }
                if (!v.netWeight) {
                v.netWeight = 0
                }
                if (!v.grossWeight) {
                v.grossWeight = 0
                }
                if (!v.packedQty) {
                v.packedQty = 0
                }
                if (this.netWeight) {
                let netWeight = cal.div(cal.mul(this.netWeight, v.qty), this.totalNum)
                v.netWeight = this.$filters.toDecimal2(netWeight)
                if (!Number(v.netWeight) > 0) {
                    v.netWeight = 0.01
                }
                }
                if (this.grossWeight) {
                let grossWeight = cal.div(cal.mul(this.grossWeight, v.qty), this.totalNum)
                v.grossWeight = this.$filters.toDecimal2(grossWeight)
                if (!Number(v.grossWeight) > 0) {
                    v.grossWeight = 0.01
                }
                }
                if (this.num) {
                let packedQty = cal.div(cal.mul(this.num, v.qty), this.totalNum)
                v.packedQty = this.$filters.toDecimal2(packedQty)
                if (!Number(v.packedQty) > 0) {
                    v.packedQty = 0.01
                }
                }
                Weightsum = cal.add(Weightsum, v.netWeight)
                grossWeightsum = cal.add(grossWeightsum, v.grossWeight)
                packedQtysum = cal.add(packedQtysum, v.packedQty)

                if (i != 0) { // 记录最大数值的索引
                if (this.selected[maxWeight].netWeight < v.netWeight) {
                    maxWeight = i
                }
                if (this.selected[maxGrossWeight].grossWeight < v.grossWeight) {
                    maxGrossWeight = i
                }
                if (this.selected[maxPackedQty].packedQty < v.packedQty) {
                    maxPackedQty = i
                }
            }
            })
            // 净重，毛重，件数，分摊后，差异的数值补在，数值最大的位上
            if (this.netWeight) {
                this.selected[maxWeight].netWeight = this.$filters.toDecimal2('toDecimal2')(
                cal.add(
                    this.selected[maxWeight].netWeight,
                    cal.sub(this.netWeight, Weightsum))
                )
            }
            if (this.grossWeight) {
                this.selected[maxGrossWeight].grossWeight = this.$filters.toDecimal2('toDecimal2')(
                cal.add(
                    this.selected[maxGrossWeight].grossWeight,
                    cal.sub(this.grossWeight, grossWeightsum))
                )
            }
            if (this.num) {
                this.selected[maxPackedQty].packedQty = this.$filters.toDecimal2('toDecimal2')(
                cal.add(
                    this.selected[maxPackedQty].packedQty,
                    cal.sub(this.num, packedQtysum))
                )
            }
        },
        exportEx () {
          let eleLink = document.createElement('a')
          eleLink.download = ''
          eleLink.style.display = 'none'
          if (this.sourceType == 'out') {
            eleLink.href = `https://zeasy-static.oss-cn-shenzhen.aliyuncs.com/${process.env.VUE_APP_ENV}/template/客户订单物料导入模板-出口.xlsx`
          } else {
            eleLink.href = `https://zeasy-static.oss-cn-shenzhen.aliyuncs.com/${process.env.VUE_APP_ENV}/template/%E5%AE%A2%E6%88%B7%E8%AE%A2%E5%8D%95%E7%89%A9%E6%96%99%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx`
          }
          document.body.appendChild(eleLink)
          eleLink.click()
          document.body.removeChild(eleLink)
        },
        beforeAvatarUpload (file) {
            console.log(123123)
            if (this.dataForm.currencyId) {
                this.exportLoading = true
                var fd = new FormData()
                fd.append('file', file)
                fd.append('currencyId', this.dataForm.currencyId)
                fd.append('bizDate', this.dataForm.bizDate)
                this.uploadReq(fd).then(res => {
                    if (res.data && res.data.code === 'C0000') {
                        this.$message({
                            message: '上传成功',
                            type: 'success',
                            duration: 1500,
                            offset: 380,
                            grouping: true,
                        })
                        res.data.result.forEach((e, i) => {
                            e._$index = 'exp-' + i
                        })
                        let temp = []
                        this.dataForm.entry.map(e => {
                            if (e.model || e.brand) {
                                temp.push(e)
                            }
                        })
                        this.dataForm.entry = temp
                        this.reuseData(this.dataForm.entry, res.data.result)
                       
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.message,
                            offset: 380,
                            grouping: true,
                        })
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.exportLoading = false
                    }, 500)
                })
                return false
            } else {
                this.exportLoading = false
                this.$message({
                    type: 'error',
                    message: '请先选择订单币别',
                    offset: 380,
                    grouping: true,
                })
            }
        },
        uploadReq (data) {
            let url = ''
            if (this.sourceType == 'import') {
                url = '/oms/client/entrustImport/clientItemImport'
            } else if (this.sourceType == 'out') {
                url = '/oms/client/entrustExport/clientItemImport'
            }
            return this.$http({
                method: 'post',
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                url: this.$adornUrl(url),
                timeout: 20000 * 10,
                data: data
            })
        },
        reuseData (entry, resultData) {
            let dataEntry = [] //合并后的真实数据
            let arry = this.$_.cloneDeep(entry) // 合并前的数据
            arry = arry.concat(resultData)
            let tempArry = this.$_.cloneDeep(arry) //合并后的垃圾数据集合
            let cal = calculation
            let isReuse = false
            let reuse = (data, parame) => {
                //先按品名+品牌+型号+产地+单价”去重，并合并数量、重量、金额
                let flag = -1
                for (let i in data) {
                    let e = data[i]
                    let element = e.brand + e.model + e.materialName + e.originPlaceName + e.price
                    let oldELement = parame.brand + parame.model + parame.materialName + parame.originPlaceName + parame.price
                    if (oldELement == element) {
                        e.qty = cal.add(e.qty, parame.qty)
                        e.packedQty = cal.add(e.packedQty, parame.packedQty)
                        e.amount = cal.add(e.amount, parame.amount)
                        e.netWeight = cal.add(e.netWeight, parame.netWeight)
                        e.grossWeight = cal.add(e.grossWeight, parame.grossWeight)
                        isReuse = true
                        flag = i
                    }
                }
                return flag
            }
            for (let index in tempArry) {
                if (reuse(dataEntry, tempArry[index]) == -1) { //没有重复的就添加到临时，数组中。
                    dataEntry.push(tempArry[index])
                }
            }
            if (isReuse) {
                this.$confirm('系统检测到有多行物料的品名、品牌、型号、产地、单价一致，请确认是否自动统计数量、重量、金额等，合并为一行展示?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.dataForm.entry = dataEntry
                }).catch(() => {
                    this.dataForm.entry = arry
                })
            } else {
                this.dataForm.entry = arry
            }
        },
        handlerDelete () {
            if (this.selected.length === 0) {
                this.$message({
                    type: 'error',
                    message: '请选择要删除的数据！',
                    offset: 380,
                    grouping: true,
                })
                return false
            }
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.selected.forEach(e => {
                    e.isDeleted = true
                    if (e.id) {
                        this.deleteArr.push(e)
                    }
                    this.removeItem(e)
                })
                this.selected = []
                this.complete()
            }).catch(() => {})
        },
        removeItem (obj) {
            let index = -1
            this.dataForm.entry.map((e,idx) => {
                if ((e.id && e.id == obj.id) || (e._$index && e._$index == obj._$index)) {
                    index = idx
                }
            })
            if (index > -1) {
                this.dataForm.entry.splice(index, 1)
            }
            this.isReload()
        },
        // 单据完善程度
        complete () {
            if (this.dataForm.entry.length === 0) {
                this.dataForm.completionDegree = '1'
            } else {
                this.dataForm.completionDegree = '2'
            }
        },
        checkboxChangeEvent ({ records }) {
            this.selected = records
        },
        cellClick (row) {
            clipboard(row.data, row.column, row.$event, this.$refs.xTable, this.dataForm.entry, this.afreshTable, row.rowIndex)
        },
        afreshTable (rowIndex, affected) { // 返回的第一个参数为 数据生成的对象，第二个参数为受影响的对象
            setTimeout(() => {

            let flag = false
            affected.map((e, idx) => {
                if (e.originPlaceName) {
                    for (let i = 0; i < this.list2.length; i ++) {
                        if (this.list2[i].label == e.originPlaceName || this.list2[i].nameEn.toLocaleUpperCase() == e.originPlaceName.toLocaleUpperCase() || e.originPlaceName.toLocaleUpperCase() == this.list2[i].number) {
                            e.originPlaceId = this.list2[i].id
                            e.originPlaceName = this.list2[i].name
                            break
                        }
                    }
                    if (!e.originPlaceId) {
                        e.originPlaceName = ''
                    }
                }
                if (e.baseUnitId) {
                    for (let i = 0; i < this.unitidArr.length; i ++) {
                        if (this.unitidArr[i].name == e.baseUnitId) {
                            e.baseUnitId = this.unitidArr[i].id
                            e.baseUnitName = this.unitidArr[i].name
                            break
                        }
                    }
                }
                
                let index = rowIndex + idx
                if (this.dataForm.entry[index]) {
                    
                    this.dataForm.entry[index] = Object.assign(this.dataForm.entry[index], e)
                    let row = this.dataForm.entry[index]
                    if (row.price && row.qty && !e.amount) {
                        row.price = this.$filters.formatNumber(row.price)
                        let sum = 0
                        sum = calculation.mul(row.price, row.qty)
                        row.amount = sum.toFixed(2)
                    } else if (row.qty && e.amount && !row.price) {
                        row.price = Number(calculation.div(e.amount, row.qty).toFixed(10))
                    }
                } else {
                    let item = {
                        model: '',
                        brand: '',
                        originPlaceId: '',
                        baseUnitId: '',
                        packingMaterial: '22',
                        price: '',
                        qty: '',
                        materialName: '',
                        productSpec: '',
                        amount: '',
                        packedQty: '',
                        netWeight: '',
                        grossWeight: '',
                        custMatNo: '',
                        _$index: new Date().getTime() + '-' + idx
                    }
                    if (e.price && e.qty) {
                        let sum = 0
                        sum = calculation.mul(e.price, e.qty)
                        e.amount = sum.toFixed(2)
                    } 
                    this.dataForm.entry.push(Object.assign(item, e))
                }
                if (e.model && e.brand) {
                    flag = true
                }
            })
            if (flag) {
                for (let i = 0; i < this.dataForm.entry.length; i ++) {
                    if (i >= rowIndex && i <= this.dataForm.entry.length) {
                        if (this.dataForm.entry[i].brand && this.dataForm.entry[i].model) {
                            this.getPageListByKey(this.dataForm.entry[i].brand, this.dataForm.entry[i].model, i)
                        }
                    }
                }
            }
            setTimeout(() => {
                this.isReload()
            }, 50)
            console.log(this.dataForm.entry)
            }, 500)
            
        },
        getPageListByKey (brand, model, i) {
            this.$post('/oms/entrustImport/pageListByKey', {
                brandName: brand,
                itemCode: model, 
                typeFlag: this.sourceType == "out" ? 2 : 1,
                status: 1,
                i: i
                }).then(({data}) => {
                if (data && data.result) {
                    let list = data.result.list
                    if (list.length > 0) {
                        this.dataForm.entry[i].customsCodeId = ''
                        this.dataForm.entry[i].colorFlag = 0
                        this.dataForm.entry[i].referPriceFrom = list[0].referPriceFrom
                        this.dataForm.entry[i].referPriceTo = list[0].referPriceTo
                        this.dataForm.entry[i].inspectionQuarantineCategoryLabel = list[0].inspectionQuarantineDesc
                        this.dataForm.entry[i].customsSupervisionConditionLabel = list[0].customsSupervisionDesc
                        this.dataForm.entry[i].customsSupervisionCondition = list[0].customsSupervision
                        this.dataForm.entry[i].inspectionQuarantineCategory = list[0].inspectionQuarantine
                        this.dataForm.entry[i].classifyStatusDesc = list[0].classifyStatusDesc
                        this.dataForm.entry[i].classifyStatus = list[0].classifyStatus
                        
                        // 判断品牌、型号字段有’无‘字
                        if (this.dataForm.entry[i].brand.indexOf('无') !== -1 || this.dataForm.entry[i].model.indexOf('无') !== -1) {

                        } else {
                            this.dataForm.entry[i].declareGoodsName = list[0].declareGoodsName
                        }
                        this.dataForm.entry[i].customsCodeName = list[0].customsCode
                        this.dataForm.entry[i].importTariffRate = list[0].enterConsumptionTaxrate
                        this.dataForm.entry[i].importVatRate = list[0].enterIncrementTaxrate
                        this.dataForm.entry[i].exportRebateRate = list[0].exitRetreatTaxrate
                        this.dataForm.entry[i].otherTaxRates = list[0].otherRate
                        this.dataForm.entry[i].materialSmallClassName = list[0].itemType
                        this.dataForm.entry[i].materialSmallClassId = list[0].sonId
                        this.dataForm.entry[i].materialId = list[0].id

                        this.dataForm.entry[i].declareGoodsArr = [] // 报关品名数据清空
                        list.forEach((v) => {
                            if (v.classifyStatus === 1) {   // 未归类状态
                                this.dataForm.entry[i].isClassify = true
                            } else if (v.classifyStatus === 3) { // 已归类状态
                                this.dataForm.entry[i].isClassify = false
                            }
                            this.dataForm.entry[i].itemElemEntryList = v.itemElemEntryList
                            this.dataForm.entry[i].importTariffRate = v.enterShutTaxrate
                            this.dataForm.entry[i].customsCodeId = v.customsCodeId
                            this.dataForm.entry[i].declareGoodsArr.push({ // 报关品名数据
                                declareGoodsName: v.declareGoodsName
                            })
                        })
                        if (this.dataForm.entry[i].declareGoodsName) {
                            this.dataForm.entry[i].classifyStatusDesc = '已归类'
                            this.dataForm.entry[i].classifyStatus = 3
                            this.dataForm.entry[i].isClassify = false
                        } else if (!this.dataForm.entry[i].declareGoodsName && this.dataForm.entry[i].declareGoodsArr.length > 0) {
                            this.dataForm.entry[i].classifyStatusDesc = '已归类'
                            this.dataForm.entry[i].classifyStatus = 3
                            this.dataForm.entry[i].isClassify = false
                        }

                        // 申报要素内容
                        if (!(!this.dataForm.entry[i].declareGoodsName && this.dataForm.entry[i].declareGoodsArr.length > 0)) {
                            let objArr = list[0].itemElemEntryList
                            let arr = []
                            objArr.forEach(e => {
                                let item = e.content
                                arr.push(item)
                            })
                            this.dataForm.entry[i].declareElementContent = arr.join('|')
                        } else {
                            this.dataForm.entry[i].declareElementContent = ''
                        }

                    } else {
                        this.dataForm.entry[i].isChangeKey = true
                        this.dataForm.entry[i].customsCodeName = ''//海关编码
                        this.dataForm.entry[i].customsCodeId = ''
                        this.dataForm.entry[i].customsCodeNumber = ''
                        this.dataForm.entry[i].declareGoodsArr = []
                        this.dataForm.entry[i].declareGoodsName = ''
                        this.dataForm.entry[i].declareGoodsNameFin = ''
                        this.dataForm.entry[i].fullDeclareElementContent = ''
                        this.dataForm.entry[i].classifyStatusDesc = '未归类'
                        this.dataForm.entry[i].classifyStatus = 1
                        this.dataForm.entry[i].declareElementContent = ''
                        this.dataForm.entry[i].importTariffRate = ''//关税
                        this.dataForm.entry[i].isInspection = ''//商检
                        this.dataForm.entry[i].isInspectionDesc = ''
                        this.dataForm.entry[i].materialId = ''
                        this.dataForm.entry[i].itemPrincipalId = ''
                    }
                }
            })
        },
        handleModel (obj, row) {
            if (obj.id) {
                row.model = obj.itemCode //品牌
                row.brand = obj.brandName// 型号
                row.productSpec = obj.productSpec//产品参数
                row.custMatNo = obj.clientNumber//料号
                row.materialName = obj.itemName//品名
                row.customsCodeName = obj.customsCode//海关编码
                if (obj.isInspectionImpDesc == '是') {
                    row.isInspection = true
                } else if (obj.isInspectionImpDesc == '否') {
                    row.isInspection = false
                }
                row.isInspectionDesc = obj.isInspectionImpDesc
                row.importTariffRate = obj.enterShutTaxRate //关税率
                if (obj.itemUnitName != "Pcs") {
                    row.baseUnitId = obj.itemUnitId //单位
                    row.baseUnitName = obj.itemUnitName
                }
                row.originPlaceName = obj.originPlaceName
                row.originPlaceId = obj.originPlaceId
                row.price = obj.price
                let sum = 0
                if (obj.price && this.row.qty) {
                    sum = cal.mul(obj.price, this.row.qty)
                }
                
                row.amount = sum.toFixed(2) || 0
                row.isMultiComponent = obj.isMultiComponent
                row.materialId = obj.relateItemId
                row.itemPrincipalId = obj.id
                row.inspectionQuarantineCategory  = obj.inspectionQuarantine
                row.customsCodeId = obj.customsCodeId
                row.isChangeKey = false
                setTimeout(() => {
                    this.modelChange(row)
                })
            }
        },
        modelChange (row) {
            let i = this.getListIndex(row)
           // this.$refs.xTable.clearActived()
            if (this.dataForm.entry[i].model && this.dataForm.entry[i].model.trim().indexOf('无') != -1) {
                this.dataForm.entry[i].model = '无型号'
            }
            if (this.dataForm.entry[i].brand && this.dataForm.entry[i].model) {
                this.getPageListByKey(this.dataForm.entry[i].brand, this.dataForm.entry[i].model, i)
            }
        },
        clearActived () {
            this.$refs.xTable.clearActived()
        },
        getListIndex (row) {
            let index = 0
            this.dataForm.entry.forEach((e, i) => {
                if ((row.id && row.id === e.id) || row._$index && row._$index === e._$index) {
                index = i
                return true
                }
            })
            return index
        },
        addTabItem (row, type) {
            
            let item = {
                model: '',
                brand: '',
                originPlaceId: '',
                baseUnitId:"2942674771050496",
                baseUnitName:"个",
                packingMaterial: '22',
                price: '',
                qty: '',
                materialName: '',
                productSpec: '',
                amount: '',
                packedQty: '',
                netWeight: '',
                grossWeight: '',
                custMatNo: '',
                _$index: new Date().getTime()
            }
            if (type) {
                let i = this.getListIndex(row)
                if (type == 'copy') {
                    let newData = this.$_.cloneDeep(row)
                    newData.id = ''
                    delete newData._X_ROW_KEY
                    newData._$index = new Date().getTime()
                    this.dataForm.entry.splice(i, 0, newData)
                } else if (type == 'befor') {
                    this.dataForm.entry.splice(i, 0, item)
                } else if (type == 'end') {
                    i += 1
                    this.dataForm.entry.splice(i, 0, item)
                }
            } else {
                this.dataForm.entry.push(item)
            }
           
            
            this.isReload()
            this.complete()
        },
        isReload () {
            this.reload = false
            this.$nextTick(() => {
                this.reload = true
            })
        },
        focusEvent2 (e) {
            let value = e.$event.target.value
            this.data2 = value ? this.list2.filter(item => item.label.indexOf(value) > -1) : this.list2
           // this.$refs.xDown2.showPanel()
        },
        keyupEvent2 (env) {
            const { value } = env
            this.data2 = value ? this.list2.filter(item => item.label.indexOf(value) > -1 || item.nameEn.toLowerCase().indexOf(value.toLowerCase()) > -1 || item.nameEn.indexOf(value) > -1 || item.number.indexOf(value) > -1 || item.number.toLowerCase().indexOf(value.toLowerCase()) > -1) : this.list2
        },
        getUnit () {
            this.$post('/bas/basMeasureUnit/all', {isNeedFilter: true}).then((res) => {
                if (res.data && res.data.code === 'C0000') {
                    this.unitidArr = res.data.result.list
                }
            }).catch((err) => {
                console.error(err)
            })
        },
        getEntrustRemarkTag () {
            this.$post('/oms/client/entrustRemarkTag/list', {data: {
                bizGroup: this.sourceType == "out" ? '02' : '01'
            }}).then(({data}) => {
                if (data && data.code == 'C0000') {
                    let list = data.result.list
                    this.remarkTag = []
                    if (list && list.length > 0) {
                        list.map((e,idx) => {
                            if (idx < 5) {
                                this.remarkTag.push(e)
                            }
                        })
                    }
                }
            })
        },
        inputOrigin (e, row) {
            setTimeout(() => {
                let temp =  this.list2.filter(item => { return item.name == row.originPlaceName })
                if (temp && temp.length > 0) {
                    row.originPlaceId = temp[0].id
                    row.originPlaceName = temp[0].label
                } else {
                    row.originPlaceId = ''
                    row.originPlaceName = ''
                }
            }, 2000)
        },
        selectEvent2 (item, row) {
            console.log(item, row)
            if (item) {
                row.originPlaceId = item.id
                row.originPlaceName = item.name
            } else {
                row.originPlaceId = ''
                row.originPlaceName = ''
            }
           // this.$refs.xDown2.hidePanel()
        },
        changeBaseUnit (env,row) {
            let i = this.getListIndex(row)
            this.unitidArr.map(e => {
                if (env.value == e.id) {
                    this.dataForm.entry[i].baseUnitName = e.name
                }
            })
        },
        //产品参数
        productSpecChange (row) {
            row.isChangeKey = true
        },
        //料号
        custMatNoChange (row) {
            row.isChangeKey = true
        },
        //品名
        materialNameChange (row) {
            row.isChangeKey = true
        },
        handlerCopyRow (row) {
            this.addTabItem(row, 'copy')
        },
        handlerAddBefor (row) {
           this.addTabItem(row, 'befor')
        },
        handlerAddEnd (row) {
            this.addTabItem(row, 'end')
        },
        handlerDelRow (row) {
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (row.id) {
                    row.isDeleted = true
                    this.deleteArr.push(row)
                }
                this.removeItem(row)
                this.isReload()
            }).catch(() => {})
        },
        // 数量
        qtyChange (row) {
            if (row.price) {
                let sum = 0
                sum = calculation.mul(row.price, row.qty)
                row.amount = sum.toFixed(2)
                
            } else if (row.amount) {
                let sum = 0
                sum = calculation.div(row.amount, row.qty).toFixed(10)
                row.price = Number(sum)
                
            }
            // this.$nextTick(() => {
            //     this.isReload = true
            // })
        },
        // 单价
        priceBlur (row) {
            if (row.qty) {
                let sum = 0
                sum = calculation.mul(row.qty, row.price)
                row.amount = sum.toFixed(2)
                if (row.materialId && row.price && this.dataForm.currencyId) {
                    this.comparePrice(row)
                }
            }
        },
        comparePrice (row) {
            this.$get('/bas/itemHisPrice/comparePrice', {materialId: row.materialId, price: row.price, currency: this.dataForm.currencyId}).then(({data}) => {
                if (data && data.code === 'C0000') {
                    row.increaseFlag = data.result
                }
            })
        },
        // 金额计算
        amountChange (row) {
            if (row.qty == 0 || !row.qty) {
                row.price = ''
            } else {
                let sum = 0
                if (Number(row.amount) != 0 && !isNaN(row.amount)) {
                    sum = Number(calculation.div(row.amount, row.qty).toFixed(10))
                    row.amount = Number(row.amount).toFixed(2)
                }
                row.price = sum
            }
        },
        // 品牌
        brandChange (row) {
            let i = this.getListIndex(row)
            if (this.dataForm.entry[i].brand && this.dataForm.entry[i].model) {
                this.getPageListByKey(this.dataForm.entry[i].brand, this.dataForm.entry[i].model, i)
            }
        //型号
        },
        handleTagClose (obj) {
            this.$get('/oms/client/entrustRemarkTag/deleteById', {id: obj.id}).then(({data}) => {
                if (data && data.code == 'C0000') {
                    this.$message({
                        type: "success",
                        message: '操作成功！'
                    })
                    this.getEntrustRemarkTag()
                }
            })
        },
        handleTagClick (obj) {
            if (this.dataForm.remark && this.dataForm.remark.trim() != '') {
                this.dataForm.remark = this.dataForm.remark + ',' + obj.content
            } else {
                this.dataForm.remark = obj.content
            }
        },
        validate () {
            return new Promise((resolve, reject) => {
                this.$refs.dataForm.validate((valid, fields) => {
                    if (valid) {
                        if (this.dataForm.entry.length == 0) {
                            this.$message({
                                type: "error",
                                message: "单据分录行未完善，请完善后再提交",
                                offset: 380,
                                grouping: true,
                            });
                            return reject('entry')
                        }
                        this.$refs.xTable.validate(true).then(valid => {
                            if (valid) {
                                return reject(msg)
                            } else {
                                return resolve(this.dataForm)
                            }
                        }).catch(msg => {
                          return reject(msg)
                        })
                        
                    } else {
                      return reject(fields)
                    }
                })
            })
        },
        modelState (row) {
            /* 在出口模块下，物料 不显示 关税率和增税率，只显示退税率，同样 在进口模块下，物料不显示 退税率，只显示关税率  增值税率  消费税率 */
            let str = ''
            if(this.sourceType == 'out'){
                if(row.exportRebateRate){
                    str += '退税 ' + row.exportRebateRate + '%'
                }
            }else{
                if (row.importTariffRate && row.importTariffRate != 0) {
                    str = '关 ' + row.importTariffRate + '%'
                }
                if (row.inspectionQuarantine && (row.inspectionQuarantine.indexOf('A') != -1 || row.inspectionQuarantine.indexOf('L'))) {
                    str += '| 检'
                }
            }
            return str
        },
        getScroll () {
            let vxeWidth = document.getElementsByClassName('cargoInfo')[0].offsetWidth
            let vxeTab = document.getElementsByClassName('scoll-vxe')[0]
            let scorll = document.getElementsByClassName('tankage')[0]
            scorll.addEventListener("scroll", function(e) {
                let t = scorll.scrollTop
                let tabTop = vxeTab.offsetTop
                let tabsHeader = document.getElementsByClassName('vxe-table--header-wrapper')[0]
                if (t - 20 >= tabTop) {
                    if (tabsHeader) {
                        tabsHeader.style.position = 'fixed'
                        tabsHeader.style.top = '110px'
                        tabsHeader.style.width = vxeWidth + 'px'
                        tabsHeader.style.zIndex = '999'
                    }
                } else {
                    if (tabsHeader) {
                        tabsHeader.style.top = '0'
                        tabsHeader.style.position = 'inherit'
                    }
                }
            });
            
        },
        qtyBlur (row) {
            
            let num = typeof row.qty == 'string' ? row.qty.toLocaleLowerCase(): row.qty + ''
            if (num.indexOf('k') != -1) {
                num = num.split('k')[0]
                num = this.$calc.mul(num, 1000)
            } else if (num.indexOf('w') != -1) {
                num = num.split('w')[0]
                num = this.$calc.mul(num, 10000)
            } else if (isNaN(num)) {
                num = ''
            }
            row.qty = num
            this.qtyChange(row)
        }
    },
    computed: {
       amountTotal: {
            get () {
                if (this.dataForm.entry) {
                    let amoutn = this.dataForm.entry.map(row => row.amount).reduce((acc, cur) => {
                        if (!cur) {
                        cur = 0
                        }
                        return calculation.add(cur, acc)
                    }, 0).toFixed(2)
                    return this.$filters.formatMoney(amoutn)
                } else {
                    return 0
                }
            },
            set (val) {
                this.amountTotal = val
            }
        },
        expectedSum () {
            if (this.dataForm.entry) {
                let sum = this.dataForm.entry.map(row => row.qty).reduce((acc, cur) => {
                    if (!cur) {
                    cur = 0
                    }
                    return calculation.add(cur, acc)
                }, 0)
                return sum
            } else {
                return 0
            }
        },
        packedQtySum: {
            get () {
                
                if (this.dataForm.entry) {
                    let qty = this.dataForm.entry.map(row => row.packedQty).reduce((acc, cur) => {
                        if (!cur) {
                        cur = 0
                        }
                        return calculation.add(cur, acc)
                    }, 0)
                    return qty
                } else {
                    return 0
                }
                
            }
        },
        netWeightSum: {
            get () {
                if (this.dataForm.entry) {
                    let netWeight = this.dataForm.entry.map(row => row.netWeight).reduce((acc, cur) => {
                        if (!cur) {
                            cur = 0
                        }
                        return calculation.add(cur, acc)
                    }, 0)
                    return netWeight
                } else {
                    return 0
                }
            },
            set (newValue) {
                let total = this.expectedSum
                this.dataForm.entry.forEach((v) => {
                let qty = v.qty
                if (!qty) {
                    qty = 0
                }
                v.netWeight = (newValue * (qty / total)).toFixed(2)
                })
            }
        },
        grossWeightSum: {
            get () {
                if (this.dataForm.entry) {
                    let grossWeight = this.dataForm.entry.map(row => row.grossWeight).reduce((acc, cur) => {
                        if (!cur) {
                            cur = 0
                        }
                        return calculation.add(cur, acc)
                    }, 0)
                    return grossWeight
                } else {
                    return 0
                }
            },
            set (newValue) {
                let total = this.expectedSum
                this.dataForm.entry.forEach((v) => {
                let qty = v.qty
                if (!qty) {
                    qty = 0
                }
                v.grossWeight = (newValue * (qty / total)).toFixed(2)
                })
            }
        },
        palletQtySum: {
            get () {
                if (this.dataForm.entry) {
                    let plletQty = this.dataForm.entry.map(row => row.palletQty).reduce((acc, cur) => {
                        if (!cur) {
                            cur = 0
                        }
                        return calculation.add(cur, acc)
                    }, 0)
                    return plletQty
                } else {
                    return 0
                }
            },
            set (newValue) {
                let total = this.expectedSum
                this.dataForm.entry.forEach((v) => {
                let qty = v.qty
                if (!qty) {
                    qty = 0
                }
                if (!v.palletQty) {
                    v.palletQty = 0
                }
                v.palletQty = (newValue * (qty / total)).toFixed(2)
                })
            }
        },
        palletQtySums: {
            get () {
                if (this.dataForm.entry) {
                    let qtySums = this.dataForm.entry.map(row => row.palletQty).reduce((acc, cur) => {
                        if (!cur) {
                            cur = 0
                        }
                        return calculation.add(cur, acc)
                    }, 0)
                    return qtySums
                } else {
                    return 0
                }
                
            },
            set (newValue) {
                let total = this.expectedSum
                this.dataForm.entry.forEach((v) => {
                let qty = v.qty
                if (!qty) {
                    qty = 0
                }
                if (!v.palletQty) {
                    v.palletQty = 0
                }
                v.palletQty = (newValue * (qty / total)).toFixed(2)
                })
            }
        },
        totalNum () {
            return this.selected.map(row => row.qty).reduce((acc, cur) => {
                if (!cur) {
                cur = 0
                }
                return calculation.add(cur, acc)
            }, 0)
        }
    },
    mounted() {
        this.getScroll()
        this.getUnit()
        if (this.sourceType == 'out') {
            this.rules.packedQty[0].required = true
            this.rules.netWeight[0].required = true
        } else {
            this.rules.packedQty[0].required = false
            this.rules.netWeight[0].required = false
        }
        this.getEntrustRemarkTag()
        this.$post('/bas/basArea/listCountry', {"type":1,"isEnabled":1,"keyWord":"","pageNum":1,"pageSize": 300}).then(({data}) => {
            if (data && data.code == 'C0000') {
                this.list2 = data.result.list
                this.data2 = this.list2
            }
        })
    }
}
</script>

<style lang="scss">
.orders-details {
    .list-tag-remak {
        .el-tag {
            cursor: pointer;
            color: #F87243;
            background-color: #FEEAE3;
            border:none;
            height: 36px;
            .remark-content {
                width: 300px;
                font-size: 15px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                display: inline-block;
            }
            .el-icon-close {
                top: -10px;
            }
            .el-icon{
                color: #999999;
                &:hover{
                    background-color: transparent !important;
                }
            }
        }
        .el-tag:not(:last-child) {
            margin-bottom: 5px;
        }
    }
    .vxe-table .red-row {
        background: #fff1f1;
    }
    .vxe-table .yellow-row {
        background: #fff7c0;
    }
    .red-cell{
        background-color: #f8839b;
        .increaseFlag_red {
        background-color: white;
        }
        .increaseFlag_blue{
        background-color: white;
        }
    }
    .blue-cell{
        background-color: #52b5ec;
        .increaseFlag_red {
        background-color: white;
        }
        .increaseFlag_blue{
        background-color: white;
        }
    }
    .ab-lert {
        margin-bottom: 20px;
    }
    .model-cls-type {
        display: inline-block;
        line-height: 20px;
        color: #f87243;
        background-color: #fdf6ec;
        padding: 5px;
        border-radius: 8px;
    }
    .edit-cls-type {
        .el-input-group__append {
            color: #f87243;
            background-color: #fdf6ec;
            box-shadow: none;
            border-radius: 8px;
            padding: 0px 8px;
        }
    }
    .addCargo {
        display: flex;
        justify-content: left;
        
        div:last-child {
            margin-left: 20px;
        }
        div {
            cursor: pointer;
            width: 90px;
            height: 45px;
        }
        .icon-svg {
            margin-right: 5px;
        }
    }
    .el-autocomplete {
        width:100%
    }
}
.tankage {
    overflow-x: hidden;
}
</style>